import React from 'react';

export default (o) =>{
	debugger
return(
	o.condition ? o.children : null
)}



// WEBPACK FOOTER //
// ./src/components/ifc.js